import { useCallback, useRef } from 'react';
import { ReportRetryManager } from '@/services/report/retry';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';

export function useReportRetry(onRetry: () => void) {
  const navigate = useNavigate();
  const retryManagerRef = useRef<ReportRetryManager | null>(null);

  const initializeRetryManager = useCallback(() => {
    if (!retryManagerRef.current) {
      retryManagerRef.current = new ReportRetryManager({
        onSuccess: () => {
          toast.success('Report loaded successfully');
        },
        onError: (error) => {
          if (error.message.includes('permission-denied')) {
            toast.error('Access denied. Redirecting to dashboard...');
            setTimeout(() => navigate('/dashboard'), 2000);
          } else {
            toast.error(error.message);
          }
        },
        onRetry
      });
    }
    return retryManagerRef.current;
  }, [navigate, onRetry]);

  const cleanup = useCallback(() => {
    if (retryManagerRef.current) {
      retryManagerRef.current.cleanup();
      retryManagerRef.current = null;
    }
  }, []);

  return {
    handleError: (error: Error) => initializeRetryManager().handleError(error),
    cleanup
  };
}